import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/industries/saas-tech/page.tsx");
